/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Copy_Config_LabelInputs */

const en_mcp_copy_config_label = /** @type {(inputs: Mcp_Copy_Config_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy configuration`)
};

const es_mcp_copy_config_label = /** @type {(inputs: Mcp_Copy_Config_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar configuración`)
};

/**
* | output |
* | --- |
* | "Copy configuration" |
*
* @param {Mcp_Copy_Config_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_copy_config_label = /** @type {((inputs?: Mcp_Copy_Config_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Copy_Config_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_copy_config_label(inputs)
	return en_mcp_copy_config_label(inputs)
});